import React, { forwardRef, useState, useEffect, useRef } from "react";
// import "../../components/CommonStyle.css";
import CalendarImg from "../../Images/calendar.png";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import InputFieldLargeDisabled from "../StyledComp/InputFieldLargeDisabled";
// import MemberServices from "../../services/MemberServices";
import DateFieldLargeDisabled from "../StyledComp/DateFieldLargeDisabled";
// import InputFieldSmallDisabled from "../StyledComp/InputFieldSmallDisabled";
// import MemberDetail from "./MemberDetail";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import "../../Styles/memberModal.css";
import { useDispatch, useSelector } from "react-redux";
import { changeCurrentMemberMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import IMember from "../../store/memberInterfaceStruct";
import ReactModal from "react-modal";

import { changeCreateMemberSection } from "../../store/screenSlice";
import MemberServices from "../../services/MemberServices";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { assignCurrentMember } from "../../store/currentMemberSlice";
import { RootState } from "../../store/store";
import {
  assignMemberPersonal,
  editMemberPersonal,
} from "../../store/editMemberapiSlice";

import {
  updateCreatememberBody,
  // updateMember_AdmitDate,
  // updateMember_BarId,
  // updateMember_DateOfBirth,
  // updateMember_Esquire,
  // updateMember_FirstName,
  // updateMember_LastName,
  // updateMember_MemberCodeId,
  // updateMember_MemberTypeId,
  // updateMember_Title,
  // updateMember_Gender,
} from "../../store/memberApiSlice";
import { isTemplateExpression } from "typescript";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { current } from "@reduxjs/toolkit";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import TextField from "@mui/material/TextField";

interface IProps {
  CurrentMember: IMember | null;
}
interface MemberCode {
  [key: string]: any;
}
interface MemberType {
  [key: string]: any;
}
interface MemberData {
  [key: string]: any;
}
interface IConfiguration {
  [key: string]: any;
}

type FormValues = {
  BarId: string;
  MemberTypeId: number;
  MemberCodeId: number;
  Title: number;
  FirstName: string;
  LastName: string;
  Esquire: string;
  Gender: string;
  DateOfBirth: Date;
  AdmitDate: Date;
  IsMediator: boolean;
  IsArbitrator: boolean;
  Comments:string;
  MediatorCertificationEndsOn: Date;
};

const MDPersonalInfo: React.FC = () => {
  const currentMember = useAppSelector((state: any) => state.currentMember);
  console.log("PersonalInfo:", currentMember);
  const dispatch = useDispatch();
  const MemberData = currentMember;
  // const [MemberData, setMemberData] = useState(currentMember);
  // const MemberData = props.CurrentMember?;
  // console.log("MemberDetail***", MemberDetail);

  const [modalOpen, setModalOpen] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);

  const form = useForm<FormValues>();
  const { register, control, handleSubmit, formState, setValue, trigger } =
    form;
  const { errors, touchedFields, dirtyFields } = formState;

  const [calculateAdmitYear, setCalculateAdmitYear] =
    useState<string>("Calculating...");
  const editMemberPersonalInfo = useSelector(
    (state: RootState) => state.editMemberapiSlice.Personal
  );

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");

  const [configurationList, setConfigurationLists] = useState<IConfiguration>(
    {}
  );

  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  useEffect(() => {
    const getConfigurationLists = async () => {
      console.log("getConfigurationLists called");
      // dispatch(resetCreateBody());

      const response = await MemberServices.getConfigurationList();
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }

        console.log("Success");
        // console.log("response1...", response.data.data);
        setConfigurationLists(response.data.data);
      } else {
      }
    };

    getConfigurationLists();

    setValue("MemberTypeId", currentMember.MemberTypeId);
    console.log("currentMember.MemberType", currentMember.AdmitDate);

    if (isInitialLoad) {
      setIsInitialLoad(false);
      let memberPersonal = {
        Id: currentMember?.Id,
        BarId: currentMember?.BarId,
        MemberTypeId: currentMember?.MemberTypeId,
        MemberCodeId: currentMember?.MemberCodeId,
        Title: currentMember?.Title,
        Esquire: currentMember?.Esquire,
        FirstName: currentMember?.FirstName,
        LastName: currentMember?.LastName,
        Comments:currentMember?.Comments,
        Gender: currentMember?.Gender,
        DateOfBirth: currentMember?.DateOfBirth?.toString().split("T")[0],
        AdmitDate: currentMember?.AdmitDate?.toString().split("T")[0],
        IsValidSupremeCourtId: currentMember?.IsValidSupremeCourtId,
        IsMediator: currentMember?.IsMediator,
        IsArbitrator: currentMember?.IsArbitrator,
        MediatorCertificationEndsOn:
          currentMember?.MediatorCertificationEndsOn?.toString().split("T")[0],
      };

      console.log("editMemberapiSlice in member home page:", memberPersonal);
      dispatch(assignMemberPersonal(memberPersonal));
    }

    const initRequiredDateFields = () => {
      if (dayjs(currentMember.AdmitDate).isValid()) {
        console.log(
          "AdmitDate isValid:",
          dayjs(currentMember.AdmitDate).isValid()
        );
        setValue("AdmitDate", new Date(currentMember.AdmitDate), {
          shouldDirty: true,
        });
      }
    };
    initRequiredDateFields();

    const calculateAdmitDate = () => {
      const today = dayjs();
      const fromDate = dayjs(currentMember.AdmitDate);

      // Calculate the difference in years and months
      const diffYears = today.diff(fromDate, "year");
      const diffMonths = today.diff(fromDate, "month") % 12;
      if (diffYears > 1 && diffMonths > 1) {
        setCalculateAdmitYear(
          diffYears + " Years and " + diffMonths + " Months"
        );
      } else if (diffYears <= 1 && diffMonths > 1) {
        setCalculateAdmitYear(
          diffYears + " Year and " + diffMonths + " Months"
        );
      } else if (diffYears > 1 && diffMonths <= 1) {
        setCalculateAdmitYear(
          diffYears + " Years and " + diffMonths + " Month"
        );
      } else {
        setCalculateAdmitYear(diffYears + " Year and " + diffMonths + " Month");
      }
    };

    calculateAdmitDate();
  }, []);

  const MemberCodes = configurationList.MemberCode;
  const MemberTypes = configurationList.MemberTypes;

  console.log("MemeberType:", MemberTypes);
  // const MemberType = props.MemberType;

  const [BarId, setbarId] = useState(currentMember.BarId);
  const [MemberType, setMemberType] = useState(currentMember.MemberType);
  const [MemberTypeId, setMemberTypeId] = useState(currentMember.MemberTypeId);
  const [MemberCodeId, setMemberCodeId] = useState(currentMember.MemberCodeId);
  const [MemberCode, setMemberCode] = useState(currentMember.MemberCode);
  const [MemberCodeDesc, setMemberCodeDesc] = useState(
    currentMember.Description
  );
  const [FirstName, setFirstName] = useState(currentMember.FirstName);
  const [LastName, setLastName] = useState(currentMember.LastName);
  const [Comments, setComments] = useState(currentMember.Comments);
  const [Gender, setGender] = useState(currentMember.Gender);
  const [Title, setTitle] = useState(currentMember.Title);
  const [Esquire, setEsquire] = useState(currentMember.Esquire);
  const [MediatorCertificationEndsOn, setMediatorCertificationEndsOn] =
    React.useState<Dayjs | null>(
      dayjs(currentMember?.MediatorCertificationEndsOn, "YYYY-MM-DD")
    );
  const [isMediator, setIsMediator] = useState<boolean>(
    currentMember?.IsMediator
  );
  const [isArbitrator, setIsArbitrator] = useState<boolean>(
    currentMember?.IsArbitrator
  );

  const [dateOfBirth, setDateOfBirth] = React.useState<Dayjs | null>(
    dayjs(currentMember?.DateOfBirth, "YYYY-MM-DD")
  );

  const [admitDate, setAdmitDate] = React.useState<Dayjs | null>(
    dayjs(currentMember?.AdmitDate, "YYYY-MM-DD")
  );

  const resetEditState = () => {
    setbarId(currentMember.BarId);
    setMemberType(currentMember.MemberType);
    setMemberTypeId(currentMember.MemberTypeId);
    setMemberCodeId(currentMember.MemberCodeId);
    setMemberCode(currentMember.MemberCode);
    setMemberCodeDesc(currentMember.Description);
    setFirstName(currentMember.FirstName);
    setLastName(currentMember.LastName);
    setComments(currentMember.Comments);
    setGender(currentMember.Gender);
    setTitle(currentMember.Title);
    setEsquire(currentMember.Esquire);
    setMediatorCertificationEndsOn(
      dayjs(currentMember?.MediatorCertificationEndsOn, "YYYY-MM-DD")
    );
    setIsMediator(currentMember?.IsMediator);
    setIsArbitrator(currentMember?.IsArbitrator);
    setDateOfBirth(dayjs(currentMember?.DateOfBirth, "YYYY-MM-DD"));
    setAdmitDate(dayjs(currentMember?.AdmitDate, "YYYY-MM-DD"));
  };
  // const [certificateEndDate, setCertificateEndDate] =
  //   React.useState<Dayjs | null>(
  //     dayjs(currentMember?.MediatorCertificationEndsOn)
  //   );

  const [lastPaidDueDate, setLastPaidDueDate] = React.useState<Dayjs | null>(
    dayjs(new Date("01/10/18"))
  );

  // const BarId = useRef<HTMLInputElement>(null);
  // const MemberTypeId = useRef<HTMLSelectElement>(null);

  const openMemberEditPersonalInfoScreen = () => {
    dispatch(
      changeCurrentMemberMenu(screenConfig.memberEditPersonalInfoScreen)
    );
  };

  const updateInput = (event: any): void => {
    // console.log("updateInput");
    console.log("updateInput1:", event.target.name);
    console.log(event.target.value);
    // console.log("currentMember1:", currentMember);

    // setMemberData(currentMember);
    // console.log("currentMember2:", currentMember);
    dispatch(
      editMemberPersonal({
        key: event.target.name,
        value: event.target.value,
      })
    );
    console.log(event.target.name, ":", event.target.value);

    switch (event.target.name) {
      case "BarId":
        setbarId(event.target.value);
        break;
      case "FirstName":
        setFirstName(event.target.value);
        break;
      case "LastName":
        setLastName(event.target.value);
        break;
      case "Comments":
        setComments(event.target.value);
        break;
      default:
        console.log("DEFAULT");
        break;
    }
  };

  const updateIsMediatorInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    flag?: string
  ): void => {
    console.log("updateIsMediator:", event.target.name);
    console.log(event.target.name, ":", event.target.value, "-Flag:", flag);

    if (flag === "isMediator") {
      setIsMediator(true);
      setIsArbitrator(false);
    } else if (flag === "isArbitrator") {
      setIsMediator(false);
      setIsArbitrator(true);
    } else {
      setIsMediator(false);
      setIsArbitrator(false);
    }
    // dispatch(updateMember_IsMediator(event.target.checked));
    console.log("isMediator:", isMediator, "&IsArbitrator", isArbitrator);
    if (flag === "isMediator") {
      dispatch(
        editMemberPersonal({
          key: "IsMediator",
          value: true,
        })
      );
      dispatch(
        editMemberPersonal({
          key: "IsArbitrator",
          value: false,
        })
      );
    } else if (flag === "isArbitrator") {
      dispatch(
        editMemberPersonal({
          key: "IsMediator",
          value: false,
        })
      );
      dispatch(
        editMemberPersonal({
          key: "IsArbitrator",
          value: true,
        })
      );
    } else {
      dispatch(
        editMemberPersonal({
          key: "IsMediator",
          value: false,
        })
      );
      dispatch(
        editMemberPersonal({
          key: "IsArbitrator",
          value: false,
        })
      );
    }
  };

  const updateSelectBox = (
    event: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    console.log("updateSelectBox");
    console.log("name:", event.target.name);
    console.log("id:", event.target.selectedIndex);
    console.log("Type:", event.target.value);

    dispatch(
      editMemberPersonal({
        key: event.target.name,
        value: event.target.value,
      })
    );
    console.log(event.target.name, ":", event.target.value);
    switch (event.target.name) {
      case "MemberTypeId":
        setMemberTypeId(event.target.value);

        break;
      case "MemberCodeId":
        const selectedMemberCode = MemberCodes.find(
          (item: any) => item.Id == event.target.value
        );
        if (selectedMemberCode) {
          setMemberCodeId(selectedMemberCode.Id);
          setMemberCode(selectedMemberCode.MemberCode);
          setMemberCodeDesc(selectedMemberCode.Description);
        }
        break;
      case "Gender":
        setGender(event.target.value);
        break;
      case "Title":
        setTitle(event.target.value);
        break;
      case "Esquire":
        setEsquire(event.target.value);
        break;
      default:
        console.log("DEFAULT");
        break;
    }
  };

  const setConsolidatedDate = (passedDate: Dayjs, type: string) => {
    console.log("setConsolidatedDate", passedDate, type);
    dispatch(
      editMemberPersonal({
        key: type,
        value: passedDate.format("YYYY-MM-DD"),
      })
    );
  };

  const emptyFunction = (event: React.ChangeEvent<HTMLInputElement>): void => {
    //empty function
  };

  const handleCancel = () => {
    setModalOpen(false);
    resetEditState();
  };

  const onSubmitEditPersonalInfo = async () => {
    // event.preventDefault();

    // if (editMemberPersonalInfo.BarId != barId) {
    //   const response = await MemberServices.checkIsBarIdDuplicate({
    //     MemberId: barId,
    //   });
    //   console.log("response", response.data);
    //joyner edit
    /*
    if (editMemberPersonalInfo.BarId != barId) {
      let response = await MemberServices.checkIsBarIdDuplicate({ MemberId: editMemberPersonalInfo.BarId,});
      if (response.data.data != null) {
        // alert("no error");
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
    */

    console.log("currentMember:", editMemberPersonalInfo);

    if (!dayjs(editMemberPersonalInfo.AdmitDate).isValid()) {
      alert("Admit Date - Invalid date format");
      return;
    }

    const response = await MemberServices.editMemberPersonal(
      editMemberPersonalInfo
    );

    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Member updated successfully");
      dispatch(assignCurrentMember(response.data.data[0]));
      // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
    } else {
      alert(response.data.errors);
      console.log("error");
    }
    setModalOpen(false);

    //

    /*
    if (editMemberPersonalInfo.BarId === barId) {
      // alert("Member updated successfully");
      console.log("editMemberBody2", editMemberPersonalInfo);
      const response = await MemberServices.editMemberPersonal(
        editMemberPersonalInfo
      );
      console.log("response", response);
      if (response.data.data != null) {
        alert("Member updated successfully");
        dispatch(assignCurrentMember(response.data.data[0]));
        // dispatch(changeCurrentMemberMenu(screenConfig.memberListScreen));
      } else {
        alert(response.data.errors);
        console.log("error");
      }
      // dispatch(assignCurrentMember(response.data.data[0]));
    } else {
      const response = await MemberServices.checkIsBarIdDuplicate({
        MemberId: editMemberPersonalInfo.BarId,
      });
      if (response.data.data != null) {
        const response = await MemberServices.editMemberPersonal(
          editMemberPersonalInfo
        );
        alert("Member updated successfully");
        console.log("response", response);
      } else {
        alert(response.data.errors);
        console.log("error");
      }
    }
    */
  };

  const color1 = "#2d6289";
  const color2 = "#008800";

  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        error: {
          main: color1,
        },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              borderBottomStyle: "solid",
              borderBottomWidth: 1,
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
      },
    });

  const handleEdit = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("members.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    setModalOpen(true);
  };

  return (
    <div className="section-box">
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Personal Information</h1>
        <PageLink onClick={() => handleEdit()}>Edit</PageLink>
        {/* <PageLink onClick={openMemberEditPersonalInfoScreen}>Edit</PageLink> */}
      </div>
      <form className="form-wrapper">
        <div className="input-field-div-wrapper">
          <Label>Bar ID</Label>
          <input
            className="input-field-div input-disabled"
            id="BarId"
            name="BarId"
            // defaultValue={MemberData?.BarId!}
            value={currentMember.BarId}
            disabled={true}
          />
        </div>
        {/* <div className="input-field-div-wrapper">
          <Label>Member Type</Label>
          <input
            className="input-field-div input-disabled"
            id="MemberType1"
            name="MemberType1"
            // defaultValue={
            //   typeof MemberData != "undefined" ? MemberData?.MemberType! : ""
            // }
            value={currentMember.MemberType!}
            disabled={true}
          />
        </div> */}
        <div className="input-field-div-wrapper">
          <Label>Member Code</Label>
          <input
            className="input-field-div input-disabled"
            id="MemberCodeId1"
            name="MemberCodeId1"
            value={
              currentMember.MemberCode + " - " + currentMember.Description!
            }
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Admit Date</Label>
          <input
            className="input-field-div input-disabled"
            id="AdmitDate"
            name="AdmitDate"
            value={
              currentMember.AdmitDate != null
                ? dayjs(currentMember.AdmitDate, "YYYY-MM-DD").format(
                    "MM-DD-YYYY"
                  )
                : "--"
            }
            // value={
            //   typeof currentMember.AdmitDate != "undefined" ||
            //   currentMember.AdmitDate != null
            //     ? currentMember.AdmitDate.split("T")[0]
            //     : ""
            // }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>First Name</Label>
          <input
            className="input-field-div input-disabled"
            id="FirstName"
            name="FirstName"
            value={currentMember.FirstName}
            disabled={true}
          />
        </div>
        <div className="input-field-div-wrapper">
          <Label>Last Name</Label>
          <input
            className="input-field-div input-disabled"
            id="LastName"
            name="LastName"
            value={currentMember.LastName}
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Title</Label>
          <input
            className="input-field-div input-disabled"
            id="Esquire"
            name="Esquire"
            value={currentMember.Esquire!}
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Suffix</Label>
          <input
            className="input-field-div input-disabled"
            id="Title"
            name="Title"
            value={currentMember.Title ? currentMember.Title : "--"}
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Gender</Label>
          <input
            className="input-field-div input-disabled"
            id="Gender"
            name="Gender"
            value={currentMember.Gender!}
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Date Of Birth</Label>
          <input
            className="input-field-div input-disabled"
            id="DateOfBirth"
            name="DateOfBirth"
            // value={currentMember.DateOfBirth.split("T")[0]}
            value={
              currentMember.DateOfBirth != null
                ? dayjs(currentMember.DateOfBirth, "YYYY-MM-DD").format(
                    "MM-DD-YYYY"
                  )
                : ""
            }
            // value={dayjs(currentMember.DateOfBirth)}
            // value={
            //   typeof currentMember.DateOfBirth != "undefined" ||
            //   currentMember.DateOfBirth != null
            //     ? currentMember.DateOfBirth.split("T")[0]
            //     : ""
            // }
            disabled={true}
          />
        </div>

        <div className="input-field-div-wrapper">
          <Label>Last Paid Dues Date</Label>
          <input
            className="input-field-div input-disabled"
            id="LastPaidDue"
            name="LastPaidDue"
            value={
              currentMember.LastMembershipDuePaidOn != null
                ? dayjs(
                    currentMember.LastMembershipDuePaidOn,
                    "YYYY-MM-DD"
                  ).format("MM-DD-YYYY")
                : "--"
            }
            // value={
            //   typeof currentMember.AdmitDate != "undefined" ||
            //   currentMember.AdmitDate != null
            //     ? currentMember.AdmitDate.split("T")[0]
            //     : ""
            // }
            disabled={true}
          />
        </div>

        {/* <div className="input-field-div-wrapper">
          <Label>Last Update Date</Label>
          <input
            className="input-field-div input-disabled"
            id="LastUpdateDate"
            name="LastUpdateDate"
            // value={
            //   typeof currentMember.AdmitDate != "undefined" ||
            //   currentMember.AdmitDate != null
            //     ? currentMember.AdmitDate.split("T")[0]
            //     : ""
            // }
            disabled={true}
          />
        </div> */}

        <div className="input-field-div-wrapper">
          <Label>Years Admitted</Label>
          <input
            className="input-field-div input-disabled"
            id="AdmitYear"
            name="AdmitYear"
            value={calculateAdmitYear}
            disabled={true}
          />
        </div>

        {/* <div
          style={{
            width: "28%",
          }}
        > */}
        <div className="input-field-div-wrapper">
          <div
            key="1"
            className="checkboxgroup"
            style={{
              height: "2.8rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            // onChange={updateInputMediator}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
              }}
            >
              <input
                id="1"
                className="checkbox"
                type="checkbox"
                checked={isMediator}
                onClick={(e) => e.preventDefault()}
                onChange={() => {}} // Empty function to satisfy the React handler requirement
              />
              <span
                style={{
                  // width: "15rem",
                  color: isMediator ? "#000000" : "#717171",
                  marginRight: "1rem",
                }}
              >
                Mediator{" "}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
              }}
            >
              <input
                id="1"
                className="checkbox"
                type="checkbox"
                {...register("IsArbitrator")}
                checked={isArbitrator}
                onClick={(e) => e.preventDefault()}
                onChange={() => {}} // Empty function to satisfy the React handler requirement
              />
              <span
                style={{
                  // width: "15rem",
                  color: isArbitrator ? "#000000" : "#717171",
                }}
              >
                Arbitrator
              </span>
            </div>
          </div>
        </div>

        {isMediator || isArbitrator ? (
          <div className="input-field-div-wrapper">
            <Label>Certification Ends On</Label>
            <input
              className="input-field-div input-disabled"
              id="CertificationEndsOn"
              name="CertificationEndsOn"
              value={
                // typeof currentMember.MediatorCertificationEndsOn !=
                //   "undefined" ||
                // currentMember.MediatorCertificationEndsOn != null
                //   ? currentMember.MediatorCertificationEndsOn?.split("T")[0]
                //   : ""
                currentMember.MediatorCertificationEndsOn != null
                  ? dayjs(
                      currentMember.MediatorCertificationEndsOn,
                      "YYYY-MM-DD"
                    )?.format("MM-DD-YYYY")
                  : "--"
              }
              disabled={true}
            />
          </div>
        ) : (
          <></>
        )}

        <div
          className="input-field-div-wrapper"
          style={{ width: "64%", height: "auto" }}
        >
          <Label>Full Address</Label>
          <div>
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? "The Honorable"
              : null}
          </div>
          <div>
            {currentMember.FirstName} {currentMember.LastName}
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? null
              : ","}
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? null
              : " Esq."}
          </div>
          {currentMember.PrimaryAddress.FirmName &&
          currentMember.PrimaryAddress.FirmName ? (
            <div>{currentMember.PrimaryAddress.FirmName}</div>
          ) : (
            <></>
          )}
          <div>
            {currentMember.PrimaryAddress.Address1}
            {currentMember.PrimaryAddress.Address2 &&
            currentMember.PrimaryAddress.Address2
              ? ", "
              : null}
            {currentMember.PrimaryAddress.Address2}
          </div>
          <div>
            {currentMember.PrimaryAddress.City}{" "}
            {currentMember.PrimaryAddress.State}{" "}
            {currentMember.PrimaryAddress.Zipcode}
          </div>
        </div>

        <div className="input-field-div-wrapper h-auto">
          <Label className="h-auto">Comments</Label>
          <div>{currentMember.Comments}</div>
          </div>

        {/* <div
          style={{
            width: "28%",
          }}
        >
          <div
            key="1"
            className="checkboxgroup"
            style={{
              height: "2.8rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            // onChange={updateInputMediator}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
              }}
            >
              <input
                id="1"
                className="checkbox"
                type="checkbox"
                checked={isMediator}
                onClick={(e) => e.preventDefault()}
                onChange={() => {}} // Empty function to satisfy the React handler requirement
              />
              <span
                style={{
                  // width: "15rem",
                  color: isMediator ? "#000000" : "#717171",
                  marginRight: "1rem",
                }}
              >
                Mediator{" "}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "left",
              }}
            >
              <input
                id="1"
                className="checkbox"
                type="checkbox"
                {...register("IsArbitrator")}
                checked={isArbitrator}
                onClick={(e) => e.preventDefault()}
                onChange={() => {}} // Empty function to satisfy the React handler requirement
              />
              <span
                style={{
                  // width: "15rem",
                  color: isArbitrator ? "#000000" : "#717171",
                }}
              >
                Arbitrator
              </span>
            </div>
          </div>

          {isMediator || isArbitrator ? (
            <div>
              <div>
                <Label>Certification Ends On</Label>
                <input
                  className="input-field-div input-disabled"
                  id="CertificationEndsOn"
                  name="CertificationEndsOn"
                  value={
                    // typeof currentMember.MediatorCertificationEndsOn !=
                    //   "undefined" ||
                    // currentMember.MediatorCertificationEndsOn != null
                    //   ? currentMember.MediatorCertificationEndsOn?.split("T")[0]
                    //   : ""
                    currentMember.MediatorCertificationEndsOn != null
                      ? dayjs(
                          currentMember.MediatorCertificationEndsOn,
                          "YYYY-MM-DD"
                        )?.format("MM-DD-YYYY")
                      : "--"
                  }
                  disabled={true}
                />
              </div>
            </div>
          ) : (
            <></>
          )}
        </div> */}
        {/* <div
          className="input-field-div-wrapper"
          style={{ width: "64%", height: "auto" }}
        >
          <Label>Full Address</Label>
          <div>
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? "The Honorable"
              : null}
          </div>
          <div>
            {currentMember.FirstName} {currentMember.LastName}
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? null
              : ","}
            {currentMember.Esquire && currentMember.Esquire.includes("Hon")
              ? null
              : " Esq."}
          </div>
          {currentMember.PrimaryAddress.FirmName &&
          currentMember.PrimaryAddress.FirmName ? (
            <div>{currentMember.PrimaryAddress.FirmName}</div>
          ) : (
            <></>
          )}
          <div>
            {currentMember.PrimaryAddress.Address1}
            {currentMember.PrimaryAddress.Address2 &&
            currentMember.PrimaryAddress.Address2
              ? ", "
              : null}
            {currentMember.PrimaryAddress.Address2}
          </div>
          <div>
            {currentMember.PrimaryAddress.City}{" "}
            {currentMember.PrimaryAddress.State}{" "}
            {currentMember.PrimaryAddress.Zipcode}
          </div>
        </div> */}
      </form>
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={() => setModalOpen(false)}
        className="editinfo-modal-large"
        overlayClassName="overlay"
      >
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">Edit Personal Information</h1>
          <PageLink onClick={() => handleCancel()}>Cancel</PageLink>
        </div>
        <form
          className="form-wrapper"
          onSubmit={handleSubmit(onSubmitEditPersonalInfo)}
          noValidate
        >
          {/* <div className="input-field-div-wrapper">
            <div className="selectfield-label">Member Type</div>
            <select
              className="dropdown-control-large-insidetextfield"
              id="MemberTypeId"
              name="MemberTypeId"
              // {...register("MemberTypeId", {
              //   required: "Member Type is a required field",
              // })}
              onChange={(e) => {
                updateSelectBox(e);
              }}
              value={MemberTypeId ?? ""}
            >
              <option value={""}>-- Member Type --</option>
              {MemberTypes?.map((MemberType: any) => (
                <option key={MemberType.Id} value={MemberType.Id}>
                  {MemberType.MemberType}
                </option>
              ))}
              ;
            </select>
            <p className="form-error">{errors.MemberTypeId?.message}</p>
          </div> */}

          <div className="input-field-div-wrapper">
            <div className="selectfield-label">Member Code</div>
            <select
              className="dropdown-control-large-insidetextfield"
              id="MemberCodeId"
              {...register("MemberCodeId", {
                required: "Member Code is a required field",
              })}
              onChange={(e) => {
                //alert("Please create order to change Member Code");
                 updateSelectBox(e);
              }}
              value={MemberCodeId ?? ""}
            >
              <option value={""}> Select Member Code </option>
              {/* <option value="">{MemberCode + "-" + MemberCodeDesc}</option> */}
              {MemberCodes?.map((MemberCode: any) => (
                <option key={MemberCode.Id} value={MemberCode.Id}>
                  {MemberCode.MemberCode} {" - "} {MemberCode.Description}
                </option>
              ))}
              ;
            </select>
            <p className="form-error">{errors.MemberCodeId?.message}</p>
          </div>

          <div className="input-field-div-wrapper">
            <Label>Bar ID</Label>
            <input
              className="input-field-div"
              id="BarId"
              {...register("BarId", {
                required: "Bar id is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              defaultValue={BarId!}
              // value={barId}
              disabled={false}
              autoComplete="off"
            />
            <p className="form-error">{errors.BarId?.message}</p>
          </div>

          <div
            style={{
              width: "28%",
              marginBottom: "1.8rem",
              marginTop: "5px",
            }}
          >
            <Controller
              control={control}
              name="AdmitDate"
              rules={{
                required: "* required field",
                validate: (value) =>
                  dayjs(value).isValid() || "Invalid date format",
              }}
              render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { error },
              }) => (
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Admit Date"
                      value={admitDate ?? null}
                      onChange={(date) => {
                        date && setConsolidatedDate(date, "AdmitDate");
                        onChange(date?.format("MM/DD/YYYY")); // for date validation
                        date && setAdmitDate(date);
                      }}
                      slotProps={{
                        textField: {
                          error: Boolean(error),
                          // helperText: error ? errors.AdmitDate?.message?.toString() : "",
                          helperText: error ? (
                            <p className="form-error">
                              {errors.AdmitDate?.message}
                            </p>
                          ) : (
                            ""
                          ),
                        },
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              )}
            />
          </div>

          <div className="input-field-div-wrapper">
            <Label>First Name</Label>
            <input
              className="input-field-div"
              id="FirstName"
              {...register("FirstName", {
                required: "First Name is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              value={FirstName}
              disabled={false}
              autoComplete="off"
            />
            <p className="form-error">{errors.FirstName?.message}</p>
          </div>
          <div className="input-field-div-wrapper">
            <Label>Last Name</Label>
            <input
              className="input-field-div"
              id="LastName"
              {...register("LastName", {
                required: "Last Name is a required field",
              })}
              onChange={(e) => {
                updateInput(e);
              }}
              value={LastName}
              disabled={false}
              autoComplete="off"
            />
            <p className="form-error">{errors.LastName?.message}</p>
          </div>

          <div className="input-field-div-wrapper mt-0">
            <div className="selectfield-label">Title</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="Esquire"
              onChange={updateSelectBox}
            >
              <option value="">{Esquire!}</option>
              <option value="Esq">Esq.</option>
              <option value="Hon">Hon.</option>
              <option value="None">None</option>
            </select>
          </div>

          <div className="input-field-div-wrapper">
            <div className="selectfield-label">Gender</div>
            <select
              className="dropdown-control-large-insidetextfield"
              id="Gender"
              name="Gender"
              // {...register("Gender", {
              //   required: "Gender is a required field",
              // })}
              onChange={(e) => {
                updateSelectBox(e);
              }}
              value={Gender ?? ""}
            >
              {/* <option value={""}>{Gender!}</option> */}
              <option value={""}> Select Gender </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Others">Unspecified</option>
            </select>
            <p className="form-error">{errors.Gender?.message}</p>
          </div>

          <div
            style={{
              width: "28%",
              marginBottom: "1.8rem",
              marginTop: "5px",
            }}
          >
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Date Of Birth"
                  value={dateOfBirth}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "DateOfBirth");
                    date && setDateOfBirth(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>

          {/* <div
            style={{
              width: "28%",
              marginBottom: "1.8rem",
              marginTop: "5px",
            }}
          >
            <ThemeProvider theme={muiDatePickerColorTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="datepicker-local"
                  label="Last Paid Dues Date"
                  value={admitDate}
                  onChange={(date) => {
                    date && setConsolidatedDate(date, "AdmitDate");
                    date && setAdmitDate(date);
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div> */}

          <div className="input-field-div-wrapper">
            <div className="selectfield-label">Suffix</div>
            <select
              className="dropdown-control-large-insidetextfield"
              name="Title"
              onChange={updateSelectBox}
            >
              <option value="">{Title!}</option>
              <option value="Jr.">Jr.</option>
              <option value="Sr.">Sr.</option>
              <option value="Ph.D">Ph.D</option>
              <option value="II">II</option>
              <option value="III">III</option>
              <option value="IV">IV</option>
              <option value="V">V</option>
              <option value="III Ph.D">III Ph.D</option>
              <option value="DOU">DOU</option>
            </select>
          </div>

          <div style={{ width: "56%" }}>
            <div
              key="1"
              className="checkboxgroup"
              style={{ height: "2.8rem", width: "100%" }}
            >
              <input
                id="1"
                className="checkbox"
                type="radio"
                name="IsMediatorOrArbitrator"
                checked={isMediator}
                onChange={(event) => updateIsMediatorInput(event, "isMediator")}
              />
              <span
                style={{
                  width: "15rem",
                }}
              >
                Mediator
              </span>
              <input
                id="1"
                className="checkbox"
                type="radio"
                name="IsMediatorOrArbitrator"
                checked={isArbitrator}
                onChange={(event) =>
                  updateIsMediatorInput(event, "isArbitrator")
                }
              />
              <span
                style={{
                  width: "15rem",
                }}
              >
                Arbitrator
              </span>
              <input
                id="1"
                className="checkbox"
                type="radio"
                name="IsMediatorOrArbitrator"
                checked={isArbitrator || isMediator ? false : true}
                onChange={(event) => updateIsMediatorInput(event, "none")}
              />
              <span
                style={{
                  width: "15rem",
                }}
              >
                none
              </span>
            </div>
          </div>
          <div style={{ width: "28%" }}>
            {isMediator || isArbitrator ? (
              <div style={{ width: "100%", marginBottom: "1.8rem" }}>
                <ThemeProvider theme={muiDatePickerColorTheme}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      className="datepicker-local"
                      label="Certification Ends On"
                      value={MediatorCertificationEndsOn}
                      onChange={(date) => {
                        date &&
                          setConsolidatedDate(
                            date,
                            "MediatorCertificationEndsOn"
                          );
                        date && setMediatorCertificationEndsOn(date);
                      }}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </div>
            ) : (
              <></>
            )}
          </div>
         

          <div style={{height: "auto" , width: "65%"}} className="input-field-div-wrapper">
            <Label>Comments</Label>
            <textarea
              className="input-field-div h-auto"
              id="Comments"
              name="Comments"
              rows={4} 
              cols={50}
              onChange={(e) => {
                updateInput(e);
              }}
              value={Comments}
              disabled={false}
              autoComplete="off"
            />
          </div>

          <div className="horizontal-wrapper-centeralign mt-3">
            <div className="submit-button-div ">
              <Button type="submit">Save</Button>
            </div>
          </div>
          {/* <DevTool control={control} /> */}
        </form>
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MDPersonalInfo;
